import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fhffj4w3rw: FaireBrandEntity = {
  token: "b_fhffj4w3rw",
  type: "brand",
  name: "Active Basic | Active USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/ec31239df6ecb28251ec38b56df3e7889b4de8d9c1d285700022d87f39c18345.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/72cbf0f45fec368a23837372f545288976d99de4220dcabdc2e44d3f414ec381.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ec31239df6ecb28251ec38b56df3e7889b4de8d9c1d285700022d87f39c18345.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72cbf0f45fec368a23837372f545288976d99de4220dcabdc2e44d3f414ec381.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.7,
  reviewCount: 293,
  isInsider: true,
  description:
    "Active Basic was established in 1989 in Los Angeles California. Initially, it operated as a fabric company, catering to the local market with top-quality materials. Over time, it transformed into a leading global supplier of women's and junior's apparel. Today, Active Basic has a strong presence in the USA, Canada, Mexico, South America, and parts of Europe. The company's success can be attributed to its unwavering commitment to delivering superior products that surpass customer expectations in terms of quality, design and affordability. With over 36 years of industry experience, Active Basic remains dedicated to providing premium yet affordable clothing for everyday wear.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:53.263Z",
    importedBy: "entity-db-cli",
  },
};
